/**
 * FilterIcon/index.js
 * desc: filter icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const FilterIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="filter icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.filter.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M0.211604 1.61C2.2316 4.2 5.9616 9 5.9616 9V15C5.9616 15.55 6.4116 16 6.9616 16H8.9616C9.5116 16 9.9616 15.55 9.9616 15V9C9.9616 9 13.6816 4.2 15.7016 1.61C16.2116 0.95 15.7416 0 14.9116 0H1.0016C0.171604 0 -0.298396 0.95 0.211604 1.61Z"/></svg>
    </IconButton>
);



export default FilterIcon;
